import { createSelector } from 'reselect';
import { initialState } from './reducer';

export const selectAddressesDomain = state => state.addressesReducer || initialState;

export const getAddressesSelector = () => createSelector(selectAddressesDomain, ({ addresses }) => addresses);

export const getIsAddressesLoadingSelector = () =>
	createSelector(selectAddressesDomain, ({ isAddressesLoading }) => isAddressesLoading);

export const getIsDownloadLoadingSelector = () =>
	createSelector(selectAddressesDomain, ({ isDownloadLoading }) => isDownloadLoading);

export const getAddressesSearchValueSelector = () =>
	createSelector(selectAddressesDomain, ({ addressesSearchValue }) => addressesSearchValue);

export const getRawPaginationSelector = () => createSelector(selectAddressesDomain, ({ pagination }) => pagination);

export const getPaginationSelector = () =>
	createSelector(selectAddressesDomain, ({ pagination }) => {
		if (!pagination || pagination?.total === 0) {
			return null;
		}

		return {
			currentPage: pagination.current_page,
			totalPages: pagination.last_page,
			perPage: pagination.per_page,
			total: pagination.total,
			from: pagination.current_page * pagination.per_page - (pagination.per_page - 1),
			to:
				pagination.current_page === pagination.last_page
					? pagination.total
					: pagination.current_page * pagination.per_page,
			isNextItem: true,
			isPrevItem: true,
			isLastItem: false,
			isFirstItem: false,
		};
	});
